module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./OrgAttrView.jsx"));
	}, "OrgAttr");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrgAttr!./src/pages/bundle-org-mgmt/OrgAttr/OrgAttrView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=OrgAttr!./src/pages/bundle-org-mgmt/OrgAttr/OrgAttrView.jsx
// module chunks = 43